import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ProductTabsPlaceholder from './ProductTabsPlaceholder'
import ReactPlaceholder from 'react-placeholder'
// import Rater from 'react-rater'
// import { Button } from 'loyal-react'
// import { ModalEvaluation } from './../ModalEvaluation'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import 'react-rater/lib/react-rater.css'
import 'react-tabs/style/react-tabs.css'
import '@loyal_template/rating.css'
import '@loyal_template/storerating.css'

class ProductTabs extends Component {
  state = { showModal: false }
  state = { hideModal: true }

  toogleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  render () {
    // const fiveStartApproval = {
    //   width: '80%'
    // }
    // const fourStartApproval = {
    //   width: '0%'
    // }
    // const threeStartApproval = {
    //   width: '0%'
    // }
    // const twoStartApproval = {
    //   width: '10%'
    // }
    // const oneStartApproval = {
    //   width: '10%'
    // }
    return (
      <ReactPlaceholder
        ready={!this.props.isLoading}
        customPlaceholder={<ProductTabsPlaceholder />}
      >
        <Tabs className={`product-tabs border-color-ui-3 mt-0 mt-md-3`}>
          <div className='tabs-area draggable border-color-ui-3 border-bottom px-2 mx-0'>
            <div className='draggable-item d-inline-block px-half'>
              <TabList className='tabs-item py-3 px-0 mx-0'>
                <Tab className='item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3'>
                  Informações
                </Tab>
                {!this.props.isVoucher && !this.props.isPhysicalVoucher && (
                  <React.Fragment>
                    <Tab
                      className={`item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3`}
                    >
                      Características
                    </Tab>

                    <Tab className='item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3'>
                      Especificações
                    </Tab>
                  </React.Fragment>
                )}

                {/* <Tab className='item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3'>
                  Avaliações
                </Tab> */}
              </TabList>
            </div>
          </div>
          <TabPanel className='tabeffect row px-2 mx-0'>
            <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
              <p
                className='txt-body-sm'
                dangerouslySetInnerHTML={{ __html: this.props.description }}
              />
            </div>
          </TabPanel>
          {!this.props.isVoucher && (
            <TabPanel className={`tabeffect row px-2 mx-0`}>
              <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
                <ul>
                  {this.props.properties
                    ? this.props.properties.map((property, index) => (
                      <li key={index}>
                        <strong className='txt-body-sm'>
                          {property.name}:
                        </strong>
                        <div
                          className='txt-body-sm'
                          dangerouslySetInnerHTML={{ __html: property.value }}
                        />
                      </li>
                    ))
                    : ''}
                </ul>
              </div>
            </TabPanel>
          )}
          <TabPanel className='tabeffect row px-2 mx-0'>
            <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
              <ul>
                {this.props.specs
                  ? this.props.specs.map((property, index) => (
                    <li key={index}>
                      <strong className='txt-body-sm'>
                        {property.name}:
                      </strong>
                      <div
                        className='txt-body-sm'
                        dangerouslySetInnerHTML={{ __html: property.value }}
                      />
                    </li>
                  ))
                  : ''}
              </ul>
            </div>
          </TabPanel>
          {/* <TabPanel className='tabeffect row px-2 mx-0'>
            <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
              <div className='row'>
                <div className='col-12 col-md-6 row product-rating-tablets'>
                  <div className='col-3 product-rating'>
                    <h1 className='txt-headline'>4.0</h1>
                  </div>
                  <div className='col-9 product-rating'>
                    <p>
                      <Rater total={5} rating={4} interactive={false} />
                    </p>
                    média de 1.000 avaliações
                  </div>
                  <div className='col-12 product-rating'>
                    <Button
                      id={'openRatingModal'}
                      name={'openRatingModal'}
                      className='btn btn-double btn-featured btn-rating-modal col-12 col-md-12'
                      text='Avaliar Produto'
                      onClick={e => this.toogleModal()}
                    />
                  </div>
                </div>
                <div className='col-12 col-md-6 row product-rating-tablets'>
                  <div className='col-12 row'>
                    <div className='col-1'>
                      <strong>5</strong>
                    </div>
                    <div className='col-auto product-rating clear'>
                      <i className='icon icon_rating' />
                    </div>
                    <div className='col-8 store-rating clear'>
                      <div className='col-12 progress radius'>
                        <div
                          className='progress-bar bg-success'
                          style={fiveStartApproval}
                        />
                      </div>
                    </div>
                    <div className='col-1'>(80%)</div>

                    <div className='col-1'>
                      <strong>4</strong>
                    </div>
                    <div className='col-auto product-rating clear'>
                      <i className='icon icon_rating' />
                    </div>
                    <div className='col-8 store-rating clear'>
                      <div className='col-12 progress radius'>
                        <div
                          className='progress-bar bg-success'
                          style={fourStartApproval}
                        />
                      </div>
                    </div>
                    <div className='col-1'>(0%)</div>

                    <div className='col-1'>
                      <strong>3</strong>
                    </div>
                    <div className='col-auto product-rating clear'>
                      <i className='icon icon_rating' />
                    </div>
                    <div className='col-8 store-rating clear'>
                      <div className='col-12 progress radius'>
                        <div
                          className='progress-bar bg-success'
                          style={threeStartApproval}
                        />
                      </div>
                    </div>
                    <div className='col-1'>(0%)</div>

                    <div className='col-1'>
                      <strong>2</strong>
                    </div>
                    <div className='col-auto product-rating clear'>
                      <i className='icon icon_rating' />
                    </div>
                    <div className='col-8 store-rating clear'>
                      <div className='col-12 progress radius'>
                        <div
                          className='progress-bar bg-success'
                          style={twoStartApproval}
                        />
                      </div>
                    </div>
                    <div className='col-1'>(10%)</div>

                    <div className='col-1'>
                      <strong>1</strong>
                    </div>
                    <div className='col-auto product-rating clear'>
                      <i className='icon icon_rating' />
                    </div>
                    <div className='col-8 store-rating clear'>
                      <div className='col-12 progress radius'>
                        <div
                          className='progress-bar bg-success'
                          style={oneStartApproval}
                        />
                      </div>
                    </div>
                    <div className='col-1'>(10%)</div>
                  </div>
                </div>
                <div className='col-12 row border-color-ui-3 border-top pt-3 mt-3 mb-3 product-rating'>
                  <Rater total={5} rating={5} interactive={false} /> Alice -
                  20/05/2018
                  <h4 className='col-12 txt-circular-book d-none d-md-block px-md-0 px-2 my-1'>
                    Produto superou minhas expectativas.
                  </h4>
                  <p className='txt-body-sm'>
                    O melhor custo beneficio disparado do mercado. Já recomendei
                    o modelo a amigos.
                    <br />
                    Meu único arrependimento é não ter comprado um modelo maior
                    (55 polegadas).
                  </p>
                </div>
                <div className='col-12 row border-color-ui-3 border-top pt-3 mb-0 product-rating'>
                  <Rater total={5} rating={1} interactive={false} /> José -
                  10/02/2018
                  <h4 className='col-12 txt-circular-book d-none d-md-block px-md-0 px-2 my-1'>
                    Problemas para repor peças
                  </h4>
                  <p className='txt-body-sm'>
                    Cuidado: Adquiri uma 55 em 11/2010, Em 11/2015 gastei
                    R$720,00 para trocar a placa. Agora preciso trocar placa
                    novamente porém a LG não produz mais peças de reposição.
                    Conclusão: vou ter jogar fora um alto investimento.
                  </p>
                  <div className='col-12 row store-rating my-3 mx-0'>
                    <div className='col-12'>
                      <p className='txt-body-sm pb-2'>
                        <strong>Resposta da loja:</strong>
                      </p>
                      <p className='txt-body-sm'>
                        Boa tarde José.
                        <br />
                        Você pode encontrar as peças que precisa acessando{' '}
                        <a className='cursor txt-left px-0 pt-1 txt-font-body color-brand-1 txt-body-sm'>
                          www.lg.com.br/acessorios
                        </a>
                        <br />
                        Qualquer dúvidas estamos a disposição na nossa{' '}
                        <a className='cursor txt-left px-0 pt-1 txt-font-body color-brand-1 txt-body-sm'>
                          central de ajuda
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-12 row py-0'>
                  <a className='cursor txt-left px-0 pt-1 txt-font-body color-brand-1 txt-body-sm'>
                    Ver mais avaliações
                  </a>
                </div>
              </div>
            </div>
            <ModalEvaluation
              show={this.state.showModal}
              onClose={e => this.toogleModal()}
            />
          </TabPanel> */}
        </Tabs>
      </ReactPlaceholder>
    )
  }
}

ProductTabs.propTypes = {
  isLoading: PropTypes.bool,
  isVoucher: PropTypes.bool,
  isPhysicalVoucher: PropTypes.bool,
  description: PropTypes.string,
  properties: PropTypes.array,
  specs: PropTypes.array
}

export default ProductTabs



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/DetailSection/ProductTabs/ProductTabs.js